<template>
  <section class="alarm-message-container"
    :style="resetStyle"
    v-if="gridData.length"
    v-drag:index-page='["mousedown_callback","mousemove_callback","mouseup_callback"]'
  >
    <el-popover
      ref="popover5"
      width="320"
      trigger="hover"
      :visible-arrow="false"
      popper-class="alarm-message__padding-patch"
      :disabled="disabled"
      :value="disabled">
      <header class="head-title">
        <label>{{$t('indexPage.alarm')}}({{gridData.length}})</label>
      </header>
      <el-scrollbar>
        <ul class="alarm-message-list hi-df hi-fdc">
          <li class="alarm-message-list-item hi-df hi-fdc" @click="goToApp(item)" v-for="(item,index) of gridData" :key="item.title">
            <span class="close-btn" @click="closeMessage(index)">
              <i class="h-icon-delete"></i>
            </span>
            <div class="hi-df hi-aic">
              <label class="hi-f1 title" :title="item.title">{{item.title}}</label>
              <p class="time">{{item.date}}</p>
            </div>
            <ul class="customer-list-warper">
              <li v-for="child of item.describe" :key="child.value" class="hi-df item">
                <label class="item-label">{{child.label}}：</label><p :title="child.value" class="item-value">{{child.value}}</p>
              </li>
            </ul>
          </li>
        </ul>
      </el-scrollbar>
    </el-popover>
    <el-badge :value="gridData.length" :max="99" class="select-none">
      <div class="alarm-btn" v-popover:popover5 ></div>
    </el-badge>
    <mps-service
      :componentSet="['portal.bs.alarm']"
      @message-get="onMessageGet"
    ></mps-service>
  </section>
</template>

<script>
import storage from 'good-storage'
import mpsService from 'components/mps-service/messager'
const options = {
  componentId:'',
  componentMenuId:'',
  callback: {},
  date: '',
  title: '',
  describe: []
}
export default {
  name: 'alarmMessage',
  data () {
    return {
      gridData: [],
      disabled: false,
      width: 40
    }
  },
  computed: {
    resetStyle () {
      return storage.get('alarm-btn-position') || { right: '32px', bottom: '100px' }
    }
  },
  components: { mpsService },
  created () {
    // let i = 0;
    // const data = {
    //   componentId:'',
    //   componentMenuId:'',
    //   callback: {},
    //   date: '2016-05-02 12:22:22',
    //   title: '告警消息',
    //   describe: [
    //     { label: '告警类型', value: '测试数据a' },
    //     { label: '告警区域', value: '测试数据b' },
    //     { label: '告警人员', value: '测试数据c'},
    //     { label: '班组班组', value: '高三12班' }
    //   ]
    // }
    // this.onMessageGet(data)
    // setInterval(()=>{
    //   i++
    //   data.title = data.title+i
    //   this.onMessageGet(data)
    // },1000)
  },
  methods: {
    async mousedown_callback () {
      await this.$nextTick()
      this.disabled = true
    },
    async mouseup_callback () {
      await this.$nextTick()
      this.disabled = false
    },
    closeMessage(index){
      this.gridData.splice(index,1)
    },
    onMessageGet(data){
      const message = Object.assign({},options,data)
      this.gridData.unshift(message)
    },
    goToApp(item){
      const {
        componentId,
        componentMenuId,
        callback
      } = item
      if(componentId && componentMenuId){
        const params = {
          componentId,
          componentMenuId,
          callback,
        }
        window.goToApp(params)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .alarm-message-container{
    position:absolute;
    z-index:101;
    cursor: move;
    .alarm-btn{
      width:40px;
      height:40px;
      background:url('../../assets/images/alarm_bg_big.png');
      background-size: 100%;
    }
  }
  .head-title{
    font-size: 14px;
    color: rgba(0,0,0,0.90);
    letter-spacing: 0;
    line-height: 20px;
    border-bottom: 1px solid rgba(0,0,0,0.12);
    padding:8px 12px;
    font-weight: 600;
  }
  .alarm-message-list{
    height: 400px;
    width:100%;
    .alarm-message-list-item{
      margin: 12px;
      cursor: pointer;
      box-shadow: 0 1px 10px 0 #DEDEDE;
      border-radius: 2px;
      border-radius: 2px;
      padding: 12px;
      cursor: pointer;
      position: relative;
      .close-btn{
        position: absolute;
        right:0px;
        bottom: -6px;
        font-size: 24px;
      }
      &:hover{
        box-shadow: 0 3px 10px 0 #DEDEDE;
      }
      .title{
        color:#333333;
        font-weight: 600;
        line-height:22px;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .time{
        font-size:12px;
        line-height:22px;
      }
      .customer-list-warper{
        .item{
          font-size:13px;
          padding:4px 0;
          &-label{
            color:#666666;
            max-width:100px;
            min-width:80px;
            // text-align: right;
            margin-right: 4px;
          }
          &-value{
             overflow:hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
        }
      }
    }

  }
</style>

<style>
.alarm-message__padding-patch{
  padding:0px;
}
</style>
